import React from "react";
import DeleteButton from "./element/DeleteButton";

function FormExperienceList({
  updateData,
  experienceId,
  itemId,
  listItemId,
  detailsItem,
  removeData,
}) {
  function handleChange(e) {
    updateData({
      category: "experienceList",
      mainId: experienceId,
      subId: itemId,
      subSubId: listItemId,
      newValue: e.target.value,
    });
  }
  function handleDelete() {
    removeData({
      category: "itemListExperience",
      mainId: experienceId,
      subId: itemId,
      subSubId: listItemId,
    });
  }
  return (
    <>
      <div className="flex gap-4">
        <div className="sm:flex items-center mb-1.5 flex-wrap">
          <label className="" htmlFor={"listItem"}>
            {"⌙List Item:"}{" "}
          </label>
          <input
            className="outline-0 border border-slate-200 rounded-sm xl:w-48 2xl:w-60  justify-start px-2 py-0.5 transition hover:border-slate-400 focus:border-slate-700"
            type="text"
            name={"listItem"}
            onChange={handleChange}
            value={detailsItem.item}
          />
        </div>
        <div className="mt-0.5">
          <DeleteButton handleDelete={handleDelete} />
        </div>
      </div>
    </>
  );
}

export default FormExperienceList;
